import type { AddressSuggestionFields } from '~~/layers/base/utils/crane/address'

/** Address-validation outcome (TK-12977). */
export type AddressResolution = 'match' | 'suggest' | 'no_match'

/** User-facing copy when Avalara resolve/config is unavailable — save must not proceed. */
export const ADDRESS_VALIDATE_UNAVAILABLE_MESSAGE =
    'Address verification is temporarily unavailable. Please try again in a moment.'

export type AddressVerifyDrawer = 'none' | 'confirm' | 'suggest_only' | 'block'

/** Layout-mounted verify drawer modes (`AddressSuggestionDrawer`). */
export type AddressSuggestionOverlayMode = 'confirm' | 'suggest_only' | 'block'

/** Wire shape for `POST /api/addresses/validate` (TK-12977). */
export type AddressValidateWireResponse =
    | { resolution: 'match'; messages: string[] }
    | {
          resolution: 'suggest'
          drawer: 'confirm' | 'suggest_only'
          suggested: AddressSuggestionFields
          messages: string[]
      }
    | { resolution: 'no_match'; drawer: 'block'; messages: string[] }

/**
 * Nick matrix: on `suggest`, manual taxability picks confirm vs suggest_only.
 * Unknown (`null`) fails open to confirm. Only used server-side for validate.
 */
export function deriveAddressVerifyDrawer(
    resolution: AddressResolution,
    manualTaxable: boolean | null = null
): AddressVerifyDrawer {
    if (resolution === 'match') {
        return 'none'
    }
    if (resolution === 'no_match') {
        return 'block'
    }
    return manualTaxable === false ? 'suggest_only' : 'confirm'
}
